import { FC, useEffect, useState } from "react";
import { useAppContext } from "../../../system/providers/appContextProvider";
import { useUserContext } from "../../../system/providers/userContextProvider";
import { PluginWrapper } from "../../../components/plugins";
import { checkAccessStatus } from "../../CommonHelperFunctions";
import DefaultDictionaryCommandsPanel from "../../../components/commandsPanels/DefaultDictionaryCommandsPanel";
import { Spinner } from "../../../components/spiner/Spinner";
import { DefaultGrid } from "../../../components/grids/default/defaultGrid";
import { StorePlaceDataProvider } from "../../../Services/DataProviders/StorePlaceDataProvider";
import { IStorePlaceViewDTO } from "../../../libs/coreapi-dto/dirs/storePlace";
import { LoadingStatus } from "../../../@types/enumsGlobal";
import useGridFilter, { CreateSelectorGridFilter } from "../../../system/hooks/useGridFilter";
import StorePlaceCreatorModal from "./StorePlaceCreatorModal";

const StorePlaceGrid: FC<IGridProps> = (props) => {
    const appCtx = useAppContext();
    const userContext = useUserContext();
    
    const storePlaceDP = new StorePlaceDataProvider(appCtx.coreApiService)

    const [data, setData] = useState<IStorePlaceViewDTO[]>([]);

    const [isSubmitting, setIsSubmitting] = useState<boolean>(true);
    const [loadingStatus, setLoadingStatus] = useState<LoadingStatus>(LoadingStatus.InProcess);
    const [totalCount, setTotalCount] = useState(0);
    const [viewState, setViewState] = useState<GridStateType>("view");
    const [gridFilter, dispatchGridFilter] = useGridFilter(props.baseGridFilter ?? CreateSelectorGridFilter);
    const [selectedItem, setSelectedItem] = useState<IGridRow>();

    useEffect(() => {
        setIsSubmitting(true)
        storePlaceDP.getView(gridFilter, (data, totalCount) => {
            setData(data);
            setTotalCount(totalCount)
            setViewState('view')
            data.length > 0 ? setLoadingStatus(LoadingStatus.Completed) : setLoadingStatus(LoadingStatus.NoData)
            setIsSubmitting(false)
        })
    }, [viewState, gridFilter])

    return ( 
        <PluginWrapper>
            {
                checkAccessStatus(props.plugin.permission as IPermission, userContext.userPermission) && 
                <>                    
                    <DefaultDictionaryCommandsPanel
                        selectedItem={[selectedItem, setSelectedItem]}
                        gridFilter={[gridFilter, dispatchGridFilter]}
                        dataProvider={storePlaceDP}
                        creatorModalJsx={StorePlaceCreatorModal}
                        pluginSettings={props.plugin}
                        setViewState={(vs) => setViewState(vs)}
                    />
                </>
            }

            {
                isSubmitting ? <Spinner /> : <DefaultGrid
                    showQuantity
                    multipleSelect={props.multipleSelect}
                    gridId={props.gridId}
                    data={data}
                    loadingStatus={loadingStatus}
                    setLoadingStatus={setLoadingStatus}
                    totalCount={totalCount}
                    filter={gridFilter}
                    dataProvider={storePlaceDP}
                    plugin={props.plugin}
                    separator
                    singleDirectory
                    selectedItem={selectedItem}
                    onDoubleClick={(row) => props.onDoubleClick?.(row)}
                    onSelect={(row) => {
                        setSelectedItem(row)
                        props.onSelect?.(row)
                    }}
                    onSort={(i) => dispatchGridFilter({ type: "sort", payload: i.propertyName })}
                    onFilterDelete={(i) => dispatchGridFilter({ type: "deleteColumnFilter", payload: i.propertyName })}
                    onPageNumberChange={(n) => dispatchGridFilter({ type: "changePageNumber", payload: { pageNumber: n } })}
                    onNumberPerPageChange={(n) => dispatchGridFilter({ type: "changeNumberPerPage", payload: { numberPerPage: n } })}
                    onEnter={() => setViewState("edit")}
                    isSearchForMultyselect={props.isSearchForMultyselect}
                />
            }
        </PluginWrapper>
    )
}

export default StorePlaceGrid